import { MaskedInput } from '../masked-input';
import { MaskedInputProps } from '../masked-input/masked-input';

// eslint-disable-next-line mobx/missing-observer
export const InputDigits = (props: Omit<MaskedInputProps, 'mask'>) => {
  return (
    <MaskedInput
      {...props}
      mask={/^\d+$/}
      maskOptions={{ lazy: true }}
      onPaste={(e) => e.preventDefault()}
    />
  );
};
